<h1 class="section-header">{{ staticTextHeader | globalTranslate }}</h1>
<hr />
<p class="static-text" [innerHTML]="this.staticText_1 | globalTranslate"></p>
<h2 class="section-header">{{ staticText_2 | globalTranslate }}</h2>
<hr />
@if (rows && rows.length) {
<div class="d-none d-lg-block">
  @if (!isMobileView) {
  <ngx-datatable
    class="bootstrap striped"
    #table
    [rows]="rows"
    [limit]="5"
    [columnMode]="'force'"
    [headerHeight]="'auto'"
    [footerHeight]="50"
    [rowHeight]="'auto'"
  >
    @for (col of columns; track col) {
    <ngx-datatable-column [name]="col.name | globalTranslate" [prop]="col.prop">
      <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
        @if (col.prop === 'changeNumber') {
        <span>{{ staticText_10 | globalTranslate }}{{ value }}</span>
        } @if (col.prop !== 'changeNumber') {
        <span>{{ value }}</span>
        }
      </ng-template>
    </ngx-datatable-column>
    }
    <ngx-datatable-column
      name="{{ this.staticText_5 | globalTranslate }}"
      [width]="148"
    >
      <ng-template
        ngx-datatable-cell-template
        let-row="rows"
        let-rowIndex="rowIndex"
      >
        <ng-container>
          @if (translatedLang !== 'en') {
          <span
            class="mobile-table-data"
            [innerHTML]="rows[rowIndex].typeOfChangeEs | globalTranslate"
          ></span>
          } @if (translatedLang === 'en') {
          <span
            class="mobile-table-data"
            [innerHTML]="rows[rowIndex].typeOfChange | globalTranslate"
          ></span>
          }
        </ng-container>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      name="{{ this.staticText_6 | globalTranslate }}"
      [width]="275"
    >
      <ng-template
        ngx-datatable-cell-template
        let-row="rows"
        let-rowIndex="rowIndex"
      >
        <ng-container>
          @if (translatedLang !== 'en') {
          <span
            class="mobile-table-data"
            [innerHTML]="rows[rowIndex].supportingDocumentsEs | globalTranslate"
          ></span>
          } @if (translatedLang === 'en') {
          <span
            class="mobile-table-data"
            [innerHTML]="rows[rowIndex].supportingDocuments | globalTranslate"
          ></span>
          }
        </ng-container>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      name="{{ this.staticText_7 | globalTranslate }}"
      [width]="245"
    >
      <ng-template
        ngx-datatable-cell-template
        let-row="rows"
        let-rowIndex="rowIndex"
      >
        <ng-container>
          <button class="btn btn-sm btn-secondary" (click)="uploadProof()">
            <span>{{ staticText_8 | globalTranslate }}</span>
          </button>
        </ng-container>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
  }
</div>
}
<div class="nh-table-mobile d-lg-none">
  @if (rows && rows.length) { @for (row of rows; track row) {
  <div class="table-row mb-3 pb-3">
    <div class="mobile-table-header">
      {{ columns[0].name | globalTranslate }}
    </div>
    <hr />
    <div class="mobile-table-data">{{ row.hohName }}</div>
    <br />
    <div class="mobile-table-header">
      {{ columns[1].name | globalTranslate }}
    </div>
    <hr />
    <div class="mobile-table-data">
      {{ staticText_10 | globalTranslate }}{{ row.changeNumber }}
    </div>
    <br />
    <div class="mobile-table-header">{{ staticText_5 | globalTranslate }}</div>
    <hr />
    @if (translatedLang !== 'en') {
    <div
      class="mobile-table-data"
      [innerHTML]="row.typeOfChangeEs | globalTranslate"
    ></div>
    } @if (translatedLang === 'en') {
    <div
      class="mobile-table-data"
      [innerHTML]="row.typeOfChange | globalTranslate"
    ></div>
    }
    <br />
    <div class="mobile-table-header">{{ staticText_6 | globalTranslate }}</div>
    <hr />
    @if (translatedLang !== 'en') {
    <div
      class="mobile-table-data"
      [innerHTML]="row.supportingDocumentsEs | globalTranslate"
    ></div>
    } @if (translatedLang === 'en') {
    <div
      class="mobile-table-data"
      [innerHTML]="row.supportingDocuments | globalTranslate"
    ></div>
    }
    <br />
    <div class="mobile-table-header">{{ staticText_7 | globalTranslate }}</div>
    <hr />
    <span>
      <button
        class="btn btn-sm btn-secondary action-button"
        style="width: 100%"
        (click)="(uploadProof)"
      >
        <span>{{ staticText_8 | globalTranslate }}</span>
      </button>
    </span>
    <br />
    <hr />
  </div>
  } } @if (!rows.length) {
  <p class="mb-5">{{ staticText_9 | globalTranslate }}</p>
  }
</div>